import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.NonWarrantyPricePoint.BulkUpdateNonWarrantyPricePoints.IRequest;
type Headers = Api.Core.NonWarrantyPricePoint.BulkUpdateNonWarrantyPricePoints.IHeaders;
type Response = Api.Core.NonWarrantyPricePoint.BulkUpdateNonWarrantyPricePoints.IResponse;
const url = '/api/ProductManagement/NonWarrantyPricePoint/BulkUpdateNonWarrantyPricePoints';
export async function bulkUpdateNonWarrantyPricePointsApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    body,
    url,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
